import React, { PropsWithChildren } from 'react';
import { Modal } from 'react-bootstrap';
import DialogBody from './Body';
import DialogFooter from './Footer';
import './index.scss';

interface DialogProps {
  open: boolean,
  dismiss: () => void,
  type?: 'default' | 'success' | 'error',
  closeButton?: boolean,
  centered?: boolean,
  className?: string,
  backdropClassName?: string,
  /** `id` do título que nomeia o diálogo para o leitor de tela (`aria-labelledby`). */
  labelledBy?: string,
}

export default function Dialog(
  {
    children,
    open,
    dismiss,
    type = 'default',
    closeButton = false,
    centered = false,
    className = '',
    backdropClassName = '',
    labelledBy,
  }: PropsWithChildren<DialogProps>,
) {
  return (
    <Modal
      show={open}
      onHide={dismiss}
      centered={centered}
      className={`dialog ${type}-dialog ${className}`.trim()}
      backdropClassName={backdropClassName || undefined}
      aria-labelledby={labelledBy}
    >
      <Modal.Header closeButton={closeButton} className={`dialog-header ${type}-dialog-header`} />
      {children}
    </Modal>
  );
}

Dialog.Body = DialogBody;
Dialog.Footer = DialogFooter;
